// src/index.ts
import { detectDupes } from "@liveblocks/core";

// src/version.ts
var PKG_NAME = "@liveblocks/client";
var PKG_VERSION = "2.15.2";
var PKG_FORMAT = "esm";

// src/index.ts
import {
  createClient,
  getMentionedIdsFromCommentBody,
  LiveList,
  LiveMap,
  LiveObject,
  shallow,
  stringifyCommentBody,
  toPlainLson
} from "@liveblocks/core";
detectDupes(PKG_NAME, PKG_VERSION, PKG_FORMAT);
export {
  LiveList,
  LiveMap,
  LiveObject,
  createClient,
  getMentionedIdsFromCommentBody,
  shallow,
  stringifyCommentBody,
  toPlainLson
};
//# sourceMappingURL=index.mjs.map